<script>
  import View from '@/views/View'
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'SolutionsItem',

    metaInfo() {
      const title = this.$t('solutions.title')
      const description = this.$t('solutions.subtitle')
      const siteUrl = process.env.VUE_APP_SITE_URL || 'https://yooxplore.com'
      return {
        title,
        meta: [
          { vmid: 'description', name: 'description', content: description },
        ],
        script: [
          {
            vmid: 'solution-jsonld',
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org',
              '@type': 'Product',
              name: title,
              description,
              url: `${siteUrl}${this.$route.path}`,
              brand: {
                '@type': 'Brand',
                name: 'Yooxplore',
              },
            },
          },
        ],
      }
    },

    extends: View,

    mixins: [
      LoadSections([
        'solution-intro',
        'keep-in-touch2',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'solution',
      },
    },
  }
</script>
